import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { catchError, Observable, of } from 'rxjs';
export interface SubFuncionalidade {
  id: string;
  nome: string;
  url: string;
  ordem: number;
  subFuncionalidades: SubFuncionalidade[];
}
export interface Funcionalidade {
  id: string;
  nome: string;
  url: string;
  ordem: number;
  subFuncionalidades: SubFuncionalidade[];
}

export interface Restricao {
  id: string;
  nome: string;
}

@Injectable({
  providedIn: 'root',
})
export class GroupPermissionsService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  getMenus() {
    return this.http.get(this.baseUrl + `/v1/menu`);
  }

  getRestricoes(): Observable<any> {
    return this.http.get(this.baseUrl + `/v1/user-profiles/restricoes`);
  }

  getPermissao(id: string) {
    return this.http.get(this.baseUrl + `/v1/permissao/${id}`);
  }

  create(data: any) {
    return this.http.post(this.baseUrl + `/v1/permissao`, data);
  }

  edit(id: string | null, data: any) {
    return this.http.patch(this.baseUrl + `/v1/permissao/${id}`, data);
  }

  getHistorico(id: string) {
    return this.http.get(this.baseUrl + `/v1/permissao/${id}/historico`);
  }

  activate(id: string) {
    return this.http.patch(this.baseUrl + `/v1/permissao/${id}/active`, {});
  }

  inactivate(id: string) {
    return this.http.patch(this.baseUrl + `/v1/permissao/${id}/inactive`, {});
  }

  delete(id: string) {
    return this.http.delete(this.baseUrl + `/v1/permissao/${id}`);
  }

  createPermissionario(id: string | null, data: any) {
    return this.http.post(
      this.baseUrl + `/v1/permissao/${id}/permissionario`,
      data
    );
  }

  updatePermissionario(id: string | null, data: any) {
    return this.http.patch(
      this.baseUrl + `/v1/permissao/${id}/permissionario`,
      data
    );
  }

  getCategorias() {
    return this.http.get(this.baseUrl + `/v1/permissao/categoria`);
  }

  getCategoriaHabilitacao() {
    return this.http.get(this.baseUrl + `/v1/habilitacao/categoria`);
  }

  getTipoEndereco() {
    return this.http.get(this.baseUrl + `/v1/enderecos/tipo`);
  }

  getEstados() {
    return this.http.get(this.baseUrl + `/v1/enderecos/estado`);
  }

  getCidades(estadoId: string) {
    return this.http.get(
      this.baseUrl + `/v1/enderecos/cidade?&idEstado=${estadoId}`
    );
  }

  getTipoContato() {
    return this.http.get(this.baseUrl + `/v1/contato/tipo`);
  }
}